"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useEvent_1 = __importDefault(require("./useEvent"));
/** Executes the provided callback when a click event occurs outside of the provided ref */
const useClickOutside = (ref, callback = () => { }, excludedClass) => {
    (0, useEvent_1.default)("click", (event) => {
        const target = event.target;
        if (!(target instanceof Element) || !ref.current) {
            return;
        }
        if (target !== ref.current &&
            !ref.current.contains(target) &&
            !(excludedClass && target.classList.contains(excludedClass))) {
            callback();
        }
    });
};
exports.default = useClickOutside;
